import TUIProfile from './index.vue';
export default TUIProfile;